import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'

import {activationTraceUrl} from '../ahp/activation-trace'
import {useActivationTraceId} from './use-activation-trace-id'

const ACTIVATION_TRACE_LINK_FLAG = 'one_copilot_telemetry_priority_sampling_staff_only'

export function useActivationTraceUrl(taskId: string | undefined, sessionId?: string): string | undefined {
  const {isBrowser} = useRuntimeEnvironment()
  const taskTraceId = useActivationTraceId(taskId)
  const sessionTraceId = useActivationTraceId(sessionId)

  if (!isBrowser || !isFeatureEnabled(ACTIVATION_TRACE_LINK_FLAG)) return undefined
  return activationTraceUrl(taskTraceId || sessionTraceId)
}
